// dashboard/frontend/src/components/Auth/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { 
    Container, 
    Paper, 
    TextField, 
    Button, 
    Typography, 
    Alert,
    Box
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '@mui/material/styles';

const Login = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [credentials, setCredentials] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await login(credentials);
            if (response) {
                // Check for saved redirect URL
                const redirectUrl = localStorage.getItem('redirectUrl');
                localStorage.removeItem('redirectUrl'); // Clear it after getting it
                
                // Navigate to the saved URL or home
                navigate(redirectUrl || '/', { replace: true });
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed');
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
                <Typography variant="h4" gutterBottom>
                    Login
                </Typography>
                
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        label="Username"
                        name="username"
                        value={credentials.username}
                        onChange={handleChange}
                        margin="normal"
                        required
                    />
                    <TextField
                        fullWidth
                        label="Password"
                        name="password"
                        type="password"
                        value={credentials.password}
                        onChange={handleChange}
                        margin="normal"
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 3 }}
                    >
                        Login
                    </Button>
                </form>

                <Box mt={2} textAlign="center">
                    <Typography variant="body2">
                        Forgot your password?{' '}
                        <Link 
                            to="/auth/forgot-password"
                            style={{ color: theme.palette.primary.main }}
                        >
                            Reset it here
                        </Link>
                    </Typography>
                </Box>

                <Box mt={2} textAlign="center">
                    <Typography variant="body2">
                        Don't have an account?{' '}
                        <Button 
                            color="primary"
                            onClick={() => navigate('/')}
                        >
                            View pricing plans
                        </Button>
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default Login;